import { createFileRoute } from '@tanstack/react-router';
import { App } from '#src/components/app';

export const Route = createFileRoute('/$')({
  component: App,
});
